import React, { useState } from 'react';
import {connect} from "trim-redux";
import { Styles } from '../../../config/design/styles';
import validator from 'validator';
import axios from 'axios';
import {Checkbox, FormControlLabel, Typography} from "@mui/material";
import Grid from '@mui/material/Grid2';
import LoadingButton from "../../components/elements/LoadingButton";
import {useNavigate} from "react-router-dom";
import PassField from "../../components/elements/fields/PassField";
import { defaultVariables } from "../../../config";
import { withStyles } from "@mui/styles";
import {useSnackbar} from "notistack";
import {updateRedux} from "../../../config/Security";
import {useTranslation} from "react-i18next";
import RayaField from "../../components/elements/fields/RayaField";
import PrivacyPolicyButton from "../../components/elements/PrivacyPolicyButton";
import UploadPrivateFile from "../fileManager/Components/UploadPrivateFile";
import TermsButton from "../../components/elements/TermsButton";

const Register = (props) => {
    const navigation = useNavigate();
    const [fields, setFields] = useState({
        first_name: '',
        last_name: '',
        father_name: '',
        address: '',
        id_number: '',
        iban: '',
        birthdate: ' ',
        password: '',
        password_confirmation: ''
    });
    const { t } = useTranslation();

    const { enqueueSnackbar } = useSnackbar();
    const [errors, setErrors] = useState({});
    const [hasPass, setHasPas] = useState(false);
    const [confirmed, setConfirmed] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [idCard, setIdCard] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newFields = { ...fields };
        let newErrors = { ...errors };
        newErrors[name] = "";
        newFields[name] = value;
        setFields(newFields);
        setErrors(newErrors);
    };

    const handleValidation = async (callback) => {
        let newErrors = {};
        let formIsValid = true;

        // Full name
        if (validator.isEmpty(fields.first_name)) {
            formIsValid = false;
            newErrors['first_name'] = t('emptyField');
        }
        if (validator.isEmpty(fields.last_name)) {
            formIsValid = false;
            newErrors['last_name'] = t('emptyField');
        }
        if (validator.isEmpty(fields.father_name)) {
            formIsValid = false;
            newErrors['father_name'] = t('emptyField');
        }
        if (validator.isEmpty(fields.iban)) {
            formIsValid = false;
            newErrors['iban'] = t('emptyField');
        }
        if (validator.isEmpty(fields.id_number)) {
            formIsValid = false;
            newErrors['id_number'] = t('emptyField');
        }
        if (validator.isEmpty(fields.address)) {
            formIsValid = false;
            newErrors['address'] = t('emptyField');
        }
        if(!idCard){
            formIsValid = false;
            newErrors['idCard'] = t('pleaseUploadAFile');
        }
        // Password
        if (validator.isEmpty(fields.password)) {

        } else if (fields.password.length < 5) {
            formIsValid = false;
            newErrors['password'] = t('weakPassword');
        }
        /*// Password confirmation
        if (validator.isEmpty(fields.password_confirmation)) {
            formIsValid = false;
            newErrors['password_confirmation'] = t('emptyField');
        } else if (fields.password_confirmation !== fields.password) {
            formIsValid = false;
            newErrors['password_confirmation'] = t('noMatchPassword');
        }*/
        if(!confirmed){
            formIsValid = false;
            newErrors['confirmed'] = t('setConfirmedError');
        }
        setErrors(newErrors);
        callback(formIsValid);
    };

    const handleRequest = async () => {
        const { first_name,last_name,father_name, birthdate, password, password_confirmation, iban, address,id_number } = fields;
        let data = new FormData();
        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        data.append('first_name', first_name);
        data.append('last_name', last_name);
        data.append('father_name', father_name);
        data.append('birthdate', birthdate);
        data.append('iban', iban);
        data.append('address', address);
        data.append('id_number', id_number);
        data.append('id_image', !!idCard ? idCard.id : '');
        // data.append('c_password', password_confirmation);

        try {
            const response = await axios.post(`${defaultVariables.url}/auth/register-step`, data, config);
            await updateRedux();
            navigation('/');
        } catch (error) {
            console.log(error.response);
            setSubmitLoading(false);
            enqueueSnackbar(t('registerError'), {
                variant: 'error',
            });
        }
        
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) {
                handleRequest();
            }else{
                setSubmitLoading(false);
            }
        });
    };

    const { classes } = props;

    return (
            <form className={classes.form} noValidate onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item size={{ xs: 12, md: 4 }}>
                        <RayaField
                            fullWidth
                            variant="outlined"
                            label={t('first_name')}
                            name="first_name"
                            autoFocus
                            onChange={handleChange}
                            error={!!errors['first_name']}
                            helperText={errors['first_name']}
                            color="violet"
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 4 }}>
                        <RayaField
                            fullWidth
                            variant="outlined"
                            label={t('last_name')}
                            name="last_name"
                            onChange={handleChange}
                            error={!!errors['last_name']}
                            helperText={errors['last_name']}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 4 }}>
                        <RayaField
                            fullWidth
                            variant="outlined"
                            label={t('father_name')}
                            name="father_name"
                            onChange={handleChange}
                            error={!!errors['father_name']}
                            helperText={errors['father_name']}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 4 }}>
                        <RayaField
                            fullWidth
                            variant="outlined"
                            value={fields.birthdate}
                            label={t('birthdate')}
                            name="birthdate"
                            type="date"
                            onChange={handleChange}
                            error={!!errors['birthdate']}
                            helperText={errors['birthdate']}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 4 }}>
                        <RayaField
                            fullWidth
                            variant="outlined"
                            label={t('id_number')}
                            name="id_number"
                            onChange={handleChange}
                            error={!!errors['id_number']}
                            helperText={errors['id_number']}
                            dir="ltr"
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 4 }}>
                        <RayaField
                            fullWidth
                            variant="outlined"
                            label={t('iban')}
                            name="iban"
                            onChange={handleChange}
                            error={!!errors['iban']}
                            helperText={errors['iban']}
                            dir="ltr"
                        />
                    </Grid>
                    <Grid item size={{ xs: 12}}>
                        <RayaField
                            fullWidth
                            variant="outlined"
                            label={t('address')}
                            name="address"
                            onChange={handleChange}
                            error={!!errors['address']}
                            helperText={errors['address']}
                            multiline
                        />
                    </Grid>

                    <Grid item size={{ xs: 12 }}>
                        <UploadPrivateFile
                            title={t('uploadIdCard')}
                            setFile={(file) => setIdCard(file)}
                        />
                        {
                            !!errors['idCard'] &&
                            <Typography className="error-text">{errors['idCard']}</Typography>
                        }
                    </Grid>
                    <Grid item size={{ xs: 12 }}>
                        <FormControlLabel
                            label={t('setPassword')}
                            control={<Checkbox color={"secondary"} checked={hasPass} onChange={() => setHasPas(!hasPass)} />}
                        />
                    </Grid>
                    {
                        !!hasPass &&
                        <Grid item size={{ xs: 12 }}>
                            <PassField
                                fullWidth
                                variant="outlined"
                                name="password"
                                label={t('password')}
                                type="password"
                                onChange={handleChange}
                                error={!!errors['password']}
                                helperText={errors['password']}
                            />
                        </Grid>
                    }

                    {/*<Grid item size={{ xs: 12 }}>
                        <PassField
                            required
                            variant="outlined"
                            fullWidth
                            name="password_confirmation"
                            label={t('passwordConfirm')}
                            placeholder={t('passwordConfirm')}
                            type="password"
                            onChange={handleChange}
                            error={!!errors['password_confirmation']}
                            helperText={errors['password_confirmation']}
                        />
                    </Grid>*/}
                </Grid>
                <Grid item size={{ xs: 12 }}>
                    <FormControlLabel
                        label={
                            <Typography>{t('setConfirmed')} <PrivacyPolicyButton/> {t('setConfirmed3')} <TermsButton/> {t('setConfirmed4')}</Typography>
                        }
                        control={<Checkbox color={"secondary"} checked={confirmed} onChange={() => setConfirmed(!confirmed)} />}
                    />
                    {
                        !!errors['confirmed'] &&
                        <Typography className="error-text">{errors['confirmed']}</Typography>
                    }
                </Grid>
                <Grid item xs={12}>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        color="primary"
                        size="large"
                        loading={submitLoading}
                        style={{width:"100%"}}
                        styleForParent={{marginBottom:0}}
                    >
                        {t('continue')}
                    </LoadingButton>
                </Grid>
            </form>
    );
};

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
    locale: state.locale,
});

export default withStyles(Styles)(connect(mstp)(Register));
